var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasAvatar)?_c('b-img',_vm._b({attrs:{"src":_vm.src,"rounded":_vm.rounded,"alt":"Avatar"}},'b-img',_vm.options,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }